import React, { Component, useEffect, useState, useRef, createRef} from 'react'
import { useIonAlert } from '@ionic/react';
import { useLocation } from 'react-router'
import {
    Grid,
    Typography,
    Drawer,
    Toolbar,
    Divider,
    Box,
    Stack,
    CssBaseline,
    List,
    ListItem,
    Avatar,
    FormControl, 
    FormLabel, 
    RadioGroup, FormControlLabel, Radio,TextField
} from '@mui/material'
import * as Loaders from '../../components/UIComponents/Loader'
import * as Icons from '../../components/UIComponents/Icons'
import * as Buttons from '../../components/UIComponents/Button'
import * as IconButtons from '../../components/UIComponents/IconButtons'
import * as Texts from '../../components/UIComponents/Text'
import * as Images from '../../components/UIComponents/Images'
import * as Forms from '../../components/UIComponents/Form'
import AppNavigator2 from '../../components/AppNavigator2'
// import Popover from '@mui/material/Popover'
// import AlwaysScrollToBottom from '../../components/AlwaysScrollToBottom'
// import TypingAnimation from '../../components/UIComponents/TypingAnimation'
// import UrlContentPreview from './UrlContentPreview'
// import SourceInfoModal from './SourceInfoModal'
import moment from 'moment'
// import { botImgObj } from '../ChatRoom'
import config from '../../config/config'
import BotHelper from '../../helpers/BotHelper';
import MustAsterik from './MustAsterik';

function isValidData(name, age, gender, dict) {
    // console.log("profile", name, typeof name, age, typeof age, gender, typeof gender)
                            
    if (!name) {
        alert(`${dict["nameValidationError"]}`)
        return false
    } else if (!age) {
        alert(`${dict["ageRequiredError"]}`)
        return false
    } else if (isNaN(parseInt(age, 10))) {
        alert(`${dict["ageValidationError"]}`)
        return false
    } else if (gender !== 'Male' && gender !== 'Female') {
        alert(`${dict["genderValidationError"]}`)
        return false
    }

    return true

}

const DemoProfile = ({
    children,
    selectedDot,
    setSelectedDot,
    history,
    defaultBots,
    loadProfile,
    botprofiles,
    bot,
    updateBotProfileBulk,
    updateBotProfile,
    dict,
    resetSession
}) => {
    // console.log('received dictionary', dict)
    // console.log("bot to be placed in demo", updateBotProfile)
    // console.log("demographic profile page is called", history)
    const _defaultBotProfile = createRef(null)
    const _name = createRef(null)
    const _age = createRef(null)
    const _gender = createRef(null)
    const _deathReason = createRef(null)
    const _otherReason = createRef(null)

    const [name, updateName] = useState("")
    const [age, updateAge] = useState("")
    const [gender, updateGender] = useState("")
    const [deathReason, updateDeathReason] = useState("")
    const [otherReason, updateOtherReason] = useState("")
    const [error, setError] = useState({})
    const [defaultBotsArr, updateDefaultBotsArr] = useState([])
    const [presentAlert] = useIonAlert()

    // this locks the useEffect so it only gets fired when users are in this page
    const location = useLocation();
    const isActive = location.pathname === '/profilesetup/demo-profile';

    const optionsArr = [
        {
            id: 'Male',
            value: 'Male',
            display: dict["male"]
        },
        {
            id: 'Female',
            value: 'Female',
            display: dict["female"]
        },
        {
            id: 'Others',
            value: 'Others',
            display: dict["othergender"]
        }
    ]

    const deathReasonOptions = [
        { id: 'Cancer', value: 'Cancer', display: dict["Cancer"] },
        { id: 'HeartFailure', value: 'HeartFailure', display: dict["HeartFailure"] },
        { id: 'COVID', value: 'COVID', display: dict["COVID"] },
        { id: 'Dementia', value: 'Dementia', display: dict["Dementia"] },
        { id: 'Accident', value: 'Accident', display: dict["Accident"] },
        { id: 'NaturalDisaster', value: 'NaturalDisaster', display: dict["NaturalDisaster"] },
        { id: 'ManmadeDisaster', value: 'ManmadeDisaster', display: dict["ManmadeDisaster"] },
        { id: 'Suicide', value: 'Suicide', display: dict["Suicide"] },
        { id: 'Homicide', value: 'Homicide', display: dict["Homicide"] },
        { id: 'Other', value: 'Other', display: dict["Other"] }
    ]

    function isValidData() {
        const errors = {}

        const name = bot?.profileObj?.name || ""
        const age = bot?.profileObj?.age || ""
        const gender = bot?.profileObj?.gender || ""
        const deathReason = bot?.profileObj?.longMem?.deathReason || ""
        const otherReason = bot?.profileObj?.longMem?.otherReason || ""

        if (!name) {
            errors.name = dict["nameHelpingText"]
        }
        if (!age) {
            errors.age = dict["ageHelpingText"]
        } else if (isNaN(parseInt(age, 10))) {
            errors.age = dict["ageValidationError"]
        }
    
        if (gender !== "Male" && gender !== "Female" && gender !== "Others") {
            errors.gender = dict["genderHelpingText"]
        }
        if (!deathReason) {
            errors.deathReason = dict["deathReasonValidationText"]
        }
        if(deathReason === "Other" && !otherReason){
            errors.otherReason = dict["otherReasonHelpingText"]
        }
    
        setError(errors)
        return errors
    }

    function showFirstError(errors) {
        const firstErrorField = Object.keys(errors)[0]
        if (firstErrorField) {
            presentAlert({
                header: dict["alertTitle"],
                message: errors[firstErrorField],
                buttons: ["OK"]
            })
        }
    }

    const clearError = (field) => {
        setError((prevErrors) => {
            const updatedErrors = { ...prevErrors }
            delete updatedErrors[field]
            return updatedErrors
        })
    }

    const handleBlur = (field, value) => {
        if (!value) {
            setError((prevErrors) => ({
                ...prevErrors,
                [field]: dict[`${field}HelpingText`]
            }))
        }
    }

    
    useEffect(() => {
        if(!isActive) return;
        // setSelectedDot(1)
        console.log("demo profile data page updated")
        if (history.location.state && history.location.state.errors) {
            console.log("errors:", history.location.state.errors)
            try{
                const errors = isValidData()
                if (Object.keys(errors).length > 0) {
                    showFirstError(errors)
                }
            }
            catch(e){}
        }

        let bots = []
        defaultBots.map((bot, idx) => {

            bots.push({
                id: bot.id,
                value: bot.id,
                display: `${bot.profileObj.condition} (${bot.profileObj.name})`
            })

        })
        updateDefaultBotsArr(bots)
        // updateName("Testing Name")
        try {
            console.log("🔍 updateBotProfile ===>", updateBotProfile)

            if (Object.keys(bot["profileObj"]).length > 0) {
                // there are existing profiles to display. Replace the current one.
                if (bot["profileObj"].hasOwnProperty("name") && bot["profileObj"]["name"] !== "") {
                    updateName(bot["profileObj"]["name"])
                }
                if (bot["profileObj"].hasOwnProperty("age") && bot["profileObj"]["age"] !== 0) {
                    updateAge(bot["profileObj"]["age"])
                }
                if (bot["profileObj"].hasOwnProperty("gender") && bot["profileObj"]["gender"] !== "") {
                    updateGender(bot["profileObj"]["gender"])
                }                 
                if (bot["profileObj"].hasOwnProperty("longMem") && typeof bot["profileObj"]["longMem"] !== "string" && bot["profileObj"]["longMem"] !== "") {
                    if(bot["profileObj"]["longMem"].hasOwnProperty("deathReason")){
                        updateDeathReason(bot["profileObj"]["longMem"]["deathReason"])
                        if(bot["profileObj"]["longMem"]["deathReason"] === "Other"){
                            updateOtherReason(bot["profileObj"]["longMem"]["otherReason"])
                        }
                    }
                }             
            }
        }
        catch (e) {

        }


    }, [
        isActive, 
        defaultBots, 
        bot
    ])

    return (<React.Fragment>
        <AppNavigator2
            title={dict["pageTitle"]}
            // sx={...your custom style}

            onBackClicked={() => {
                presentAlert({
                    header: dict["isBackToLoginTitle"],
                    message: dict["isBackToLoginMessage"],
                    buttons: [
                        {
                            text: dict["cancelText"],
                            role: "cancel"
                        },
                        {
                            text: dict["yesText"],
                            handler: () => {
                                // resetSession()
                                return history.push('/')
                            }
                        }
                    ]
                })
                return false
            }}

            onBackToChatRoomClicked={
                bot?.id && bot?.profileObj?.isEditProfile === true ?  () => { 
                    presentAlert({
                        header: dict["isBackToChatRoomTitle"],
                        message: dict["isBackToChatRoomMessage"],
                        buttons: [
                            {
                                text: dict["cancelText"],
                                role: "cancel"
                            },
                            {
                                text: dict["yesText"],
                                handler: () => {
                                    return history.push('/chatroom/pdfbot');
                                }
                            }
                        ]
                    })
                } : null
            }
        />
        <Grid container
            direction={{
                xs: "column",
                md: "row"
            }}
            sx={{
                flex: 1,
                bgcolor: 'background.gray',
                height: `calc(100vh - ${config.headerHeight}px)`,
                overflowY: {
                    sm: "scroll",
                    md: "hidden"
                }
            }}
        >
            {/** The left image and progress indicator */}
            <Grid item
                sx={{
                    flex: {
                        xs: .2,
                        sm: .2,
                        md: 1
                    },
                    height: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: {
                        sm: 'center',
                        md: "flex-start"
                    },
                    alignItems: "center"
                    // bgcolor: 'background.default'
                }}
            >
                {/*<Stack
                    direction={"column"}
                    justifyContent={{
                        xs: "center",
                        lg: "flex-start"
                    }}
                    alignItems={"center"}
                    spacing={4}
                    sx={{
                        // bgcolor: 'background.dark',
                        width: 1,
                        px: {
                            xs: 4,
                            sm: 6,
                            md: 8
                        },
                        py: {
                            xs: 4,
                            sm: 6,
                            md: 8
                        }
                    }}
                >
                    <Texts.H4
                        sx={{
                            color: 'primary.dark'
                        }}
                    >Avatar Profile Setup</Texts.H4>
                    <Texts.Tip>In this section, you will be guided through the profile setup steps. The whole process can take up to 10 minutes.</Texts.Tip>
                    <Box
                        sx={{
                            width: '240px',
                            display: {
                                xs: 'none',
                                md: 'block'
                            }
                        }}
                    >
                        <Images.DemoProfile />
                    </Box>
                <DotIndicator selectedDot={selectedDot} setSelectedDot={setSelectedDot} />
                </Stack>*/}
                {children}
            </Grid>
            <Grid item
                sx={{
                    flex: 1,
                    height: {
                        md: 1
                    },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: "flex-start",
                    alignItems: "center",
                    bgcolor: 'background.default',
                    overflowY: "scroll",
                    width: '100%',
                    maxWidth: '100%',
                }}
            >
                <Stack
                    spacing={4}
                    direction={"column"}
                    sx={{
                        width: 1,
                        px: {
                            xs: 4,
                            sm: 6,
                            md: 8
                        },
                        py: {
                            xs: 4,
                            sm: 6,
                            md: 8
                        }
                    }}
                >
                    <Box>
                        <Texts.Tip><MustAsterik />{`${dict["asterik"]}`}</Texts.Tip>
                    </Box>
                    {/* The template is just confusing. Remove it */}
                    {/* <Texts.Tip>{dict["sectionTip"]}</Texts.Tip>
                    <Forms.SelectItem
                        // ref={r => this._select = r}
                        label={dict["selectProfileTitle"]}
                        id='profile-selection'
                        inputValue={bot["id"] ? bot["id"] : ""}
                        handleInput={e => {
                            // console.log(e.target.value)
                            const selectedBotId = e.target.value
                            // console.log("new bot", newBot)
                            // load the profile in reducer and also add them into the relevant form inputs
                            loadProfile({
                                profileObj: botprofiles[selectedBotId]
                            })
                            // console.log(botprofiles[selectedBotId])
                            updateName(botprofiles[selectedBotId]["name"])
                            updateAge(botprofiles[selectedBotId]["age"])
                            updateGender(botprofiles[selectedBotId]["gender"])
                            updateDeathReason("")
                        }}
                        options={defaultBotsArr}
                    />
                    <Divider />*/}

                    <Box>
                        <Texts.Tip>{dict["name"]}<MustAsterik /></Texts.Tip>
                        <Forms.TextInput
                            ref={_name}
                            // type={this.state.hidePass ? "password" : "text"}
                            // label='Name'
                            aria-label='name'
                            icon='envelope'
                            onChange={(e) => {
                                const nameValue = e.target.value
                                updateName(nameValue)
                                updateBotProfile({
                                    key: 'name',
                                    value: nameValue
                                })
                                clearError("name")
                            }}
                            onBlur={(e) => {handleBlur("name", e.target.value)}}
                            value={name || ""}
                            error={error.name || ""}
                            helperText={dict["nameHelpingText"]}
                        />
                    </Box>
                    <Box>
                        <Texts.Tip>{dict["age"]}<MustAsterik /></Texts.Tip>
                        <Forms.TextInput
                            ref={_age}
                            type={"number"}
                            // label='Age'
                            aria-label='age'
                            min={0}
                            max={120}
                            icon='envelope'
                            onChange={(e) => {
                                const ageValue = Math.max(0, Math.min(130, e.target.value))
                                updateAge(ageValue)
                                updateBotProfile({
                                    key: 'age',
                                    value: ageValue
                                })
                                clearError("age")
                            }}
                            onBlur={(e) => {handleBlur("age", e.target.value)}}
                            value={age || ""}
                            error={error.age || ""}
                            helperText={dict["ageHelpingText"]}
                        />
                    </Box>
                    <Box>
                        <Texts.Tip sx={{ mb: 1 }}>{dict["gender"]}<MustAsterik /></Texts.Tip>
                        <Forms.SelectItem
                            ref={_gender}
                            label={dict["genderHelpingText"]}
                            id='agent-gender'
                            inputValue={gender}
                            handleInput={e => {
                                const genderValue = e.target.value
                                updateGender(genderValue)
                                updateBotProfile({
                                    key: 'gender',
                                    value: genderValue
                                })
                                clearError("gender")
                            }}
                            onBlur={(e) => {handleBlur("gender", e.target.value)}}
                            options={optionsArr}
                            error={error.gender || ""}
                        />
                    </Box>
                    
                    <Box>
                        <Texts.Tip sx={{ mb: 1 }}>{dict["deathReason"]}<MustAsterik /></Texts.Tip>
                        <Forms.SelectItem
                            ref={_deathReason}
                            label={dict["deathReasonHelpingText"]}
                            id="agent-death-reason"
                            inputValue={deathReason || ""}
                            handleInput={e => {
                                const deathReasonValue = e.target.value
                                if (deathReasonValue === "Other") {
                                    updateOtherReason("")
                                }
                                updateDeathReason(deathReasonValue)
                                updateBotProfileBulk({
                                    profileObj: {
                                        ...bot.profileObj,
                                        longMem: {
                                            ...bot.profileObj.longMem,
                                            'deathReason': deathReasonValue
                                        }
                                    }
                                })
                                clearError("deathReason")
                            }}
                            options={deathReasonOptions}
                            onBlur={(e) => {handleBlur("deathReason", e.target.value)}}
                            error={error.deathReason || ""}
                        />
                        {deathReason === "Other" && (
                            <Box>
                                <Forms.TextInput
                                    ref={_otherReason}
                                    label={dict["otherReasonHelpingText"]}
                                    value={otherReason || ""}
                                    onChange={e => {
                                        const otherReasonValue = e.target.value
                                        updateOtherReason(otherReasonValue)
                                        updateBotProfileBulk({
                                            profileObj: {
                                                ...bot.profileObj,
                                                longMem: {
                                                    ...bot.profileObj.longMem,
                                                    'otherReason': otherReasonValue
                                                }
                                            }
                                        })
                                        clearError("otherReason")
                                    }}
                                    onBlur={(e) => {handleBlur("otherReason", e.target.value)}}
                                    error={error.otherReason || ""}
                                />
                            </Box>
                        )}
                    </Box>

                    <Stack
                        spacing={4}
                        direction={"row"}
                        justifyContent={"space-between"}
                    >
                        <Buttons.SecondaryButton
                            onClick={() => {
                                history.push("/profilesetup/user-profile")
                                setSelectedDot(0)
                                // console.log(`the name is ${name}`)
                                // console.log(`the age is ${age}`)
                                // console.log(`the gender is ${gender}`)

                            }}
                        >
                            {dict["prev"]}
                        </Buttons.SecondaryButton>
                            <Buttons.Button
                                style={{
                                    marginLeft: "auto",
                                    marginRight: "0px"
                                }}
                                onClick={() => {
                                    const errors = isValidData()
                                    if (Object.keys(errors).length > 0) {
                                        showFirstError(errors)
                                    } else {
                                        setSelectedDot(1)
                                        updateBotProfileBulk({
                                            profileObj: {
                                                name: name,
                                                age: age,
                                                gender: gender,
                                                ...bot.profileObj,
                                                longMem: {
                                                    ...bot.profileObj.longMem,
                                                    deathReason: deathReason,
                                                    otherReason: otherReason
                                                }
                                            }
                                        })
                                        history.push({
                                            pathname: "/profilesetup/life-details",
                                            state: {
                                                direction: 'forward', // Customize the direction of the transition
                                            }
                                            
                                        })
                                        setSelectedDot(2)
                                    }
                                }}
                            >   
                                {dict["next"]}
                            </Buttons.Button>
                    </Stack>
                </Stack>
            </Grid>
        </Grid>

    </React.Fragment>)
}

export default DemoProfile
